// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workspace-submenu-root {
  min-height: 0;
}

.workspace-submenu-navigation {
  scrollbar-color: rgba(31, 35, 41, .38) transparent;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
  overscroll-behavior: contain;
  flex: 0 auto;
  min-height: 0;
  overflow-y: auto;
}

.workspace-submenu-navigation::-webkit-scrollbar {
  width: 7px;
}

.workspace-submenu-navigation::-webkit-scrollbar-thumb {
  background-color: rgba(31, 35, 41, .38);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 9999px;
  min-height: 32px;
}

.workspace-submenu-navigation::-webkit-scrollbar-thumb:hover {
  background-color: rgba(31, 35, 41, .6);
}

.workspace-submenu-navigation::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0);
}

.workspace-submenu-favorites {
  flex: 1 1 0;
  min-height: 0;
}

.styled-scrollbar-hidden {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.styled-scrollbar-hidden::-webkit-scrollbar {
  display: none;
}

.styled-scrollbar-hidden:hover {
  scrollbar-width: auto;
}

.styled-scrollbar-hidden:hover::-webkit-scrollbar {
  background-color: rgba(0, 0, 0, 0);
  width: 11px;
  height: 11px;
  display: inline-block;
}

.styled-scrollbar-hidden:hover::-webkit-scrollbar-thumb {
  background-color: rgba(31, 35, 41, .3);
  background-clip: padding-box;
  border: 2px solid rgba(0, 0, 0, 0);
  border-radius: 9999px;
  transition: background .2s cubic-bezier(.34, .69, .1, 1);
}

.styled-scrollbar-hidden:hover::-webkit-scrollbar-thumb:hover {
  background-color: rgba(31, 35, 41, .6);
}

.styled-scrollbar-hidden:hover::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0);
}

.list-top-mask, .list-bottom-mask {
  position: relative;
}

.list-bottom-mask:after, .list-top-mask:before {
  pointer-events: none;
  content: "";
  height: 40px;
  position: absolute;
  left: 0;
  right: 0;
}

.list-top-mask:before {
  background: linear-gradient(#fff, rgba(0, 0, 0, 0));
  top: 0;
}

.list-bottom-mask:after {
  background: linear-gradient(to top, #fff, rgba(0, 0, 0, 0));
  bottom: 0;
}

.list-top-mask-24:before {
  top: 24px;
}

.list-bottom-mask-32:after {
  bottom: 32px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
